import { MessageCircle } from "lucide-react";
import { COMPANY, openWhatsApp } from "@/lib/site";

export const WhatsAppFloat = () => (
  <a
    href={COMPANY.whatsappUrl}
    target="_blank"
    rel="noopener noreferrer"
    onClick={openWhatsApp}
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 group"
    data-testid="floating-whatsapp-btn"
  >
    <span className="absolute inset-0 rounded-full bg-brand-whatsapp/60 animate-pulse-ring" />
    <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-brand-whatsapp text-white shadow-2xl shadow-emerald-500/40 hover:scale-110 transition-transform">
      <MessageCircle className="w-7 h-7" />
    </span>
    <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
      Chat with us
    </span>
  </a>
);
